export default {
  meta: {
    title: '拓店标准版-门店签约',
    url: '/standardstore/index', // 埋点字段，上报归属的模块
    urlName: '拓店标准版' // 埋点字段，上报归属的模块
  }
};
